// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export function buildPipeCollection(items: string[] | number[]): string {
  return items.join("|");
}
